// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { GLOBAL_CONSTANT } from '../../../../../contants/global.const';
import { SEND_SERVICE } from '../../../../../services/send.service';

@Injectable({
  providedIn: 'root',
})
export class CcoService {
  public showPopupFeedController = new Subject();
  readonly sendService = inject(SEND_SERVICE);
  readonly Global = inject(GLOBAL_CONSTANT);

  public getCcoDraft<T>(taskId): Observable<T> {
    const url = this.Global.services.legalRequest.ccoDraft();
    return this.sendService.get(url, { params: { taskId } });
  }

  public saveDraft<T>(body, parameters): Observable<T> {
    const url = this.Global.services.legalRequest.ccoDraft();
    return this.sendService.put(url, body, { params: parameters });
  }
}
